(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sf-home-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('sf-home-motion')) return;
  class SfHomeMotion extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.visible = false;
      this.manualPause = matchMedia('(prefers-reduced-motion: reduce)').matches || Boolean(navigator.connection?.saveData);
      this.video.muted = true;
      this.video.playsInline = true;
      this.button.addEventListener('click', () => {
        this.manualPause = !this.video.paused;
        this.sync();
      }, options);
      this.video.addEventListener('play', () => this.updateButton(), options);
      this.video.addEventListener('pause', () => this.updateButton(), options);
      this.video.addEventListener('loadeddata', () => this.setAttribute('data-ready', ''), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
        this.sync();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.warmObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !this.manualPause && !document.hidden) {
          this.prepare('metadata');
          this.warmObserver.unobserve(this);
        }
      }, { rootMargin: '400px 0px', threshold: 0 });
      this.warmObserver.observe(this);
      this.updateButton();
    }
    updateButton() {
      const playing = !this.video.paused;
      const label = playing ? 'Pause video' : 'Play video';
      this.button.setAttribute('aria-label', label);
      this.button.setAttribute('title', label);
      this.button.setAttribute('aria-pressed', String(playing));
    }
    prepare(preload) {
      const source = this.video.querySelector('source[data-sf-src]');
      if (source) {
        this.video.preload = preload;
        source.src = source.dataset.sfSrc;
        source.removeAttribute('data-sf-src');
        this.video.load();
      }
    }
    sync() {
      if (!this.visible || this.manualPause || document.hidden) {
        this.video.pause();
        return;
      }
      this.prepare('auto');
      this.video.play().catch(() => this.updateButton());
    }
    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      this.warmObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('sf-home-motion', SfHomeMotion);
})();
  } catch(e) { console.error(e); }
})();

})();
